module.exports = __webpack_public_path__ + "img/Temperus.8dd9f95d.png";